import { createContext } from "react";
// the classified Context is:
// - undefined during initialization
// - null in case of Error
// - a Classified object otherwise
export const ClassifiedContext = createContext(undefined);
export const ClassifiedProvider = ClassifiedContext.Provider;
